import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const MoveIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Move",
    children: /*#__PURE__*/_jsx("path", {
      d: "m29.47 14.78-3.5-3.5c-.7-.7-1.75-.7-2.45 0s-.7 1.75 0 2.45l.53.53h-6.3v-6.3l.53.53c.7.7 1.75.7 2.45 0s.7-1.75 0-2.45l-3.5-3.5c-.7-.7-1.75-.7-2.45 0l-3.5 3.5c-.7.7-.7 1.75 0 2.45s1.75.7 2.45 0l.53-.53v6.3h-6.3l.52-.53c.7-.7.7-1.75 0-2.45s-1.75-.7-2.45 0l-3.5 3.5c-.7.7-.7 1.75 0 2.45l3.5 3.5c.7.7 1.75.7 2.45 0s.7-1.75 0-2.45l-.53-.52h6.3v6.3l-.53-.53c-.7-.7-1.75-.7-2.45 0s-.7 1.75 0 2.45l3.5 3.5c.7.7 1.75.7 2.45 0l3.5-3.5c.7-.7.7-1.75 0-2.45s-1.75-.7-2.45 0l-.53.53v-6.3h6.3l-.53.53c-.7.7-.7 1.75 0 2.45s1.75.7 2.45 0l3.5-3.5c.7-.7.7-1.75 0-2.45Z"
    })
  }));
};